import React from 'react';
import { Box, Button } from '@mui/material';
import { colors } from '../../../theme';
import { DarkTextField } from './DarkTextField';

interface EmailCaptureFormProps {
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  placeholder?: string;
  isSubmitting?: boolean;
}

export const EmailCaptureForm: React.FC<EmailCaptureFormProps> = ({
  email,
  onEmailChange,
  onSubmit,
  placeholder = 'Enter your email',
  isSubmitting = false,
}) => {

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: '12px',
        maxWidth: '500px',
        margin: '0 auto 24px',
      }}
    >
      <DarkTextField
        type="email"
        placeholder={placeholder}
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        required
        disabled={isSubmitting}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting}
        sx={{
          backgroundColor: colors.signalOrange,
          color: colors.pureWhite,
          fontWeight: 600,
          padding: '16px 32px',
          borderRadius: '8px',
          textTransform: 'none',
          fontSize: '1rem',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: colors.signalOrangeHover,
            transform: 'translateY(-1px)',
            boxShadow: colors.shadows.orange,
          },
          '&:disabled': {
            backgroundColor: colors.slate[600],
            color: colors.slate[400],
          },
        }}
      >
        {isSubmitting ? 'Submitting...' : 'Request Early Access'}
      </Button>
    </Box>
  );
};
